<template>
    <div>
        <v-card>
            <v-col cols="12" sm="12" md="12">
                <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                        <v-btn icon dark @click="dialog_Editor = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Editor</v-toolbar-title>
                    </v-toolbar>
                </v-card>
                <v-card class="box">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="9" md="9">
                            <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="textEditor">
                            <span><v-icon class="icon-quick" title="Copy text" @click="copy(textEditor)">mdi-content-copy</v-icon></span>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    export default {
        data: () => ({
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            textEditor: null,
        }),
        updated: function () {
            this.$nextTick().then(() => {
                if (window.MathJax) {
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                }
            });
        },
        methods: {
            copy(text) {
                navigator.clipboard.writeText(text);
                //   alert("Text copied to clipboard!!!");
                this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
            },
        },
    };
</script>
